import { hmacGenerator } from '@/services/hash/hmac'

export default defineNuxtPlugin(async ({ ssrContext }) => {
  const userAgent = ssrContext
    ? ssrContext.event?.node?.req?.headers?.['user-agent']
    : window?.navigator?.userAgent

  const { ADDRESS_CSRF_KEY } = useRuntimeConfig().public

  // Генерируем токен для списка адресов
  const token = userAgent
    ? await hmacGenerator(ADDRESS_CSRF_KEY, userAgent)
    : ''

  return {
    provide: { token },
  }
})
